module.exports = __webpack_public_path__ + "img/quality.8948c35b.svg";